<template>
    <div>

        <PageHeader>
            {{ $t('reportsPriceDistribution') }}
            <template #side>
                <div class="d-flex gap-3">
                    <ButtonResetFilters @click="resetFilters()" />
                    <TimeRangeCalendar ref="TimeRangeCalendar" v-model="timeRange" compare-year />
                </div>
            </template>
        </PageHeader>

        <PriceDistribution />

        <PriceDeviations />

    </div>
</template>



<script>
    import ButtonResetFilters from '@/components/common/ButtonResetFilters.vue';
    import TimeRangeCalendar from '@/components/common/TimeRangeCalendar.vue';
    import PriceDistribution from './parts/PriceDistribution.vue';
    import PriceDeviations from './parts/PriceDeviations.vue';

    export default {
        name: 'ReportsPriceDistribution',
        components: {
            ButtonResetFilters,
            TimeRangeCalendar,
            PriceDistribution,
            PriceDeviations,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                timeRange: null,
            };
        },
        methods: {
            resetFilters() {
                this.$emit('resetFilters');
                this.$refs.TimeRangeCalendar.resetDate();
            },
        },
    };
</script>
